


















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
  }
})

export default class DeletedAccountModal extends Vue {
    @Prop() private isTop! : boolean;
    @Prop() private isSns! : boolean;

    title = "ログアウトしました";
    message1 = "現在ご利用頂いているアカウントからログアウトしました。";

    onOk(){
        if(this.isTop || this.$router.currentRoute.path == "/signIn"){
            this.$emit("close");
        }
        else if(this.isSns){
            this.$router.push("/SelectTemplate");
        }
        else{
            this.$router.push("/signIn");
        }
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            background: this.userConfigColor
        };
        return style;
    }
}
